/* eslint-disable no-undef */
import FinanceSummary from './finance-summary';
import ImageUtils from '../../utils/image-utils';
import SessionTabs from '../../utils/session-tabs';

export default class CheckoutSession {
    constructor(parent) {
        this.data = parent.data;
        this.hashManager = parent.hashManager;
        this.car = parent.car;
        this.pricing = parent.pricing;
        this.finance = parent.finance;
        this.partEx = parent.partEx;
        this.financeSummary = parent.financeSummary;
        this.init();
    }

    init() {
        SessionTabs.share('ma2-checkout');
    }

    update() {
        const data = this.create();
        sessionStorage.setItem('ma2-checkout', JSON.stringify(data));
    }

    static remove() {
        sessionStorage.removeItem('ma2-checkout');
    }

    create() {
        const data = {};

        const mtoce = this.car.mtoce();
        const additionalProducts = this.pricing.getCarAdditionalProducts({ optionalAdditionalProducts: true }).map((p) => p.id);
        data.productIdList = [mtoce, ...additionalProducts];

        if (this.hashManager.has('orderId')) {
            data.orderId = this.hashManager.get('orderId');
        }

        if (this.partEx.enabled) {
            data.partEx = this.partEx?.result?.valuationResponse;
        }

        if (this.finance.type && this.finance.type !== 'cash' && this.finance.result) {
            data.financeContraints = this.createFinanceContraints();
            data.financeIndicative = this.createFinanceIndicative();
            data.financeSummary = FinanceSummary.create(this.finance);
        }

        data.dealStack = this.createDealStack();
        data.temp = this.createTempData();

        return data;
    }


    createFinanceContraints() {
        return this.finance?.currentParams;
    }

    createFinanceIndicative() {
        const financeIndicative = this.finance?.result;
        financeIndicative.campaignCode = this.finance?.currentParams?.campaignCode;
        return financeIndicative;
    }

    createDealStack() {
        const finance = `${+(this.finance?.result?.amountFinanced?.grossValue ?? 0)}`;
        const holdingDeposit = `${+(this.pricing.getCarHoldingFee() ?? 0)}`;
        const dealerContribution = '0';
        const financeContribution = `${this.finance?.getFinanceContribution() ?? 0}`;
        const pxSettlement = `${-(+(this.partEx?.result?.outstandingFinanceAmount ?? 0))}`;
        const pxValuation = `${+(this.partEx?.result?.valuationAmount ?? 0)}`;
        const customerFunds = Number(finance ?? 0)
            + Number(holdingDeposit ?? 0)
            + Number(financeContribution ?? 0);
        const customerBalance = `${this.pricing.getCarTotalPrice() - customerFunds}`;

        return {
            finance,
            holdingDeposit,
            dealerContribution,
            financeContribution,
            pxSettlement,
            pxValuation,
            customerBalance,
        };
    }

    createTempData() {
        const carData = this.car.data();
        const colourTrim = this.car.colourTrim();

        return {
            configuratorUrl: window.location.href,
            ids: {
                mtoce: this.car.mtoce(),
                modelCode: this.data?.model?.modelBodyCode,
                gradeCode: carData.gradeCode,
                colourCode: colourTrim.colour,
            },
            labels: {
                modelName: this.data?.model?.modelBodyName,
                gradeName: carData.gradeName,
            },
            prices: {
                orderTotal: `${+this.pricing.getCarTotalPrice() ?? 0}`,
            },
            leadTime: this.createLeadTime(),
        };
    }

    createLeadTime() {
        const carPricingData = this.pricing.carMTOCEPricing;
        const additionalProductsData = this.pricing.getCarAdditionalProducts();

        return {
            mtoce: {
                model: carPricingData?.c_modelCode ?? '',
                type: carPricingData?.c_typeCode ?? '',
                option: carPricingData?.c_optionCode ?? '',
                colour: carPricingData?.c_hesColourCode ?? '',
                euroOption: carPricingData?.c_euroOptionCode ?? '',
            },
            additionalProduct: additionalProductsData
                .filter((product) => product?.c_additionalProductCode)
                .map((product) => {
                    return {
                        code: product?.c_additionalProductCode ?? '',
                        type: product?.c_additionalProductType ?? '',
                        description: product?.c_additionalProductDescription ?? '',
                    }
                }),
        };
    }
}
